export default {
  googleApiKey: process.env.GOOGLE_API_KEY,
  stripePublicKey: process.env.STRIPE_PUBLIC_KEY,
  googleMapID: process.env.GOOGLE_MAP_ID,
}
